import React from 'react'
import { postLogout } from '@core/Areas/Login/helpers'

export const LogoutPage = () => {
  React.useEffect(() => {
    postLogout()
  }, [])

  return null
}
